import { ReferralsReports } from 'components/ReferralsReports';
import { Page } from 'layouts/Page';
import { FC } from 'react';

export const ReferralsReportsPage: FC = () => {
	return (
		<Page title="Referrals Reports – EAS Control Center">
			<ReferralsReports />
		</Page>
	);
};
